import { Container } from "@mui/system";
import { QueryClient, QueryClientProvider } from "react-query";
import { NavLinks } from "routes";
import React, { useEffect, useState } from "react";
import "./App.css";
import AlertRefresh from "ReusableComponents/customalert/AlertRefresh";
import "./i18n";
import { LanguageProvider } from "LanguageContext";
import { useTranslation } from "react-i18next";

const App = () => {
  const [isNewVersion, setIsNewVersion] = useState(false);
  const { i18n } = useTranslation();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const utm_medium = queryParams.get("utm_medium");
    const utm_source = queryParams.get("utm_source");
    const utm_campaign = queryParams.get("utm_campaign");
    const gclid = queryParams.get("gclid");
    if (utm_medium || utm_source || utm_campaign || gclid) {
      sessionStorage.setItem("utm_medium", utm_medium);
      sessionStorage.setItem("utm_source", utm_source);
      sessionStorage.setItem("utm_campaign", utm_campaign);
      sessionStorage.setItem("gclid", gclid);
    }
    localStorage.setItem("appVersion", process.env.REACT_APP_VERSION);
    const storedVersion = localStorage.getItem("appVersion");
    const currentVersion = process.env.REACT_APP_VERSION;
    if (storedVersion !== currentVersion) {
      setIsNewVersion(true);
    }
  }, []);

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);
  const queryClient = new QueryClient();

  return (
    <LanguageProvider>
      <Container style={{ maxWidth: 1800, padding: 0, position: "relative" }}>
        {isNewVersion && <AlertRefresh />}
        <QueryClientProvider client={queryClient}>
          <NavLinks />
        </QueryClientProvider>
      </Container>
    </LanguageProvider>
  );
};

export default App;